import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DocketTemplateFormValues } from "../types";
import { Switch, View } from "react-native-ui-lib";
import { Label } from "@towersystems/roam-common-native";

export interface AutomaticallyPrintInputProps {}

export const AutomaticallyPrintInput = ({}: AutomaticallyPrintInputProps) => {
  const { t } = useTranslation("settings");
  const { control } = useFormContext<DocketTemplateFormValues>();
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Label
        label={t("form.docket_template_print_automatically.label")}
      ></Label>
      <Controller
        name="automaticallyPrint"
        control={control}
        render={({ field: { onChange, value, onBlur } }) => (
          <View>
            <Switch
              value={value}
              onValueChange={(value: boolean) => {
                onChange(value);
              }}
            />
          </View>
        )}
      />
    </View>
  );
};
